// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"u0-z"};